
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { CommonFieldManagerDirective, FIELD_TOKEN } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { TextfieldStateService } from "./textfield-state.service";

@Component({
    selector: "common-textfield",
    templateUrl: "./common-textfield.component.html",
    exportAs: "CommonTextfield",
    providers: [
        CommonFieldManagerDirective,
        {provide: FieldStateService, useClass: TextfieldStateService},
        {provide: FIELD_TOKEN, useValue: "commonFormTextfields"},
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonTextfieldComponent implements OnDestroy, AfterViewInit {
    public state$: Subscription;
    public fieldValue: Date | string | number;

    @HostBinding("class.u-display-flex") public isFlex = true;

    constructor(public fieldManager: CommonFieldManagerDirective,
                public fieldStateService: FieldStateService,
                public changeDetectorRef: ChangeDetectorRef) {
    }

    public ngAfterViewInit() {
        this.state$ = this.fieldStateService.stateObservable$.pipe(
            map((state) => state.fieldValue))
            .subscribe((fieldValue) => {
                this.fieldValue = fieldValue;
                this.changeDetectorRef.markForCheck();
            });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public get isDateField() {
        return this.fieldManager.fieldType === "date";
    }

    public get isTextField() {
        return this.fieldManager.fieldType === "text";
    }

    public get isNumField() {
        return this.fieldManager.fieldType === "number";
    }

    public get isFloatField() {
        return this.fieldManager.fieldType === "float";
    }

    public get isTextareaField() {
        return this.fieldManager.fieldType === "textarea";
    }

    public get isRuntimeField() {
        return this.fieldManager.fieldType === "runtime";
    }

    public get isBreakLengthField() {
        return this.fieldManager.fieldType === "breakLength";
    }

    public get modelValue() {
        return this.fieldManager.fieldValue;
    }
}
